import { PropertyFilterQuery } from '@cloudscape-design/collection-hooks';
import { DateRangePickerProps } from '@cloudscape-design/components';

import { Order, OrdersReportRead } from '../types';

import { getAllQueryResource, getQueryResource, getReportResource } from './query';
import { getMetaQueryResource } from './meta';

const ORDER_FREE_TEXT_PROPERTY_KEY = 'venue_name';

function withOrderFreeTextSearchKey(query?: PropertyFilterQuery): PropertyFilterQuery | undefined {
  if (!query) {
    return query;
  }

  return {
    ...query,
    tokens: query.tokens.map((token) => ({
      ...token,
      propertyKey: token.propertyKey || ORDER_FREE_TEXT_PROPERTY_KEY,
    })),
  };
}

export async function getOrders(
  query?: PropertyFilterQuery,
  page = 1,
  limit = 50,
  range?: DateRangePickerProps.Value | null,
  sortingField?: string,
  sortDirection?: 'asc' | 'desc',
  now = new Date(),
  signal?: AbortSignal,
) {
  return await getQueryResource<Order>(
    '/orders',
    withOrderFreeTextSearchKey(query),
    page,
    limit,
    range,
    now,
    'rent_time',
    sortingField,
    sortDirection,
    signal,
  );
}

export async function getOrdersMeta(signal?: AbortSignal) {
  return await getMetaQueryResource('/orders/meta', signal);
}

export async function getAllOrders(
  query?: PropertyFilterQuery,
  range?: DateRangePickerProps.Value | null,
  sortingField?: string,
  sortDirection?: 'asc' | 'desc',
  now = new Date(),
  signal?: AbortSignal,
) {
  return await getAllQueryResource<Order>(
    '/orders',
    withOrderFreeTextSearchKey(query),
    1000,
    range,
    now,
    'rent_time',
    sortingField,
    sortDirection,
    signal,
  );
}

export async function getOrderReport(
  query?: PropertyFilterQuery,
  range?: DateRangePickerProps.Value | null,
  now = new Date(),
  signal?: AbortSignal,
) {
  return await getReportResource<OrdersReportRead>(
    '/orders/report',
    withOrderFreeTextSearchKey(query),
    range,
    now,
    'rent_time',
    signal,
  );
}
